// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { ComponentType } from "react";
import { connect } from "react-redux";

export type ProductCardView = "table" | "grid" | "mini" | "small";

export const ProductCardViewMapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

interface ProductCardProps<StylesType> extends HasProductContext {
    showPartNumbers?: boolean;
    showPrice?: boolean;
    showAvailability?: boolean;
    showAddToCart?: boolean;
    showAddToList?: boolean;
    showBrand?: boolean;
    showTextBadges?: boolean;
    showImageBadges?: boolean;
    maximumNumberOfTextBadges?: number;
    maximumNumberOfImageBadges?: number;
    extendedStyles?: StylesType;
    actionsTemplate?: (product: ProductModel) => React.ReactNode;
}

export type CommonProductCardProps<StylesType> = ProductCardProps<StylesType> &
    ReturnType<typeof ProductCardViewMapStateToProps>;

export const withProductCardCommonProps = (Component: ComponentType<any>) =>
    connect(ProductCardViewMapStateToProps)(Component);
